export function deepenKey(part1: string, part2: string|number):string{
    return part1 + "_" + part2;
}

export default interface IUniformNode<NodeType>{

    renderWithManualKey(): NodeType;
    render(seedKey: string): NodeType;

}